<template>
  <Loader v-if="deletionRequestLoader" />

  <div v-else class="deletion-request">
    <div v-if="deletionRequestStatus === false && deletionRequestError === null">
      <p>{{ $t('accountSettings.deletionrequest.available') }}</p>

      <button
        class="link-button"
        @click="openModalRequest"
      >{{ $t('accountSettings.deletionrequest.buttondelete') }}</button>
    </div>

    <div v-if="deletionRequestStatus === false && deletionRequestError === 'balance_below_zero'">
      <p>{{ $t('accountSettings.deletionrequest.balancebelowzero') }}</p>
    </div>

    <div v-if="deletionRequestStatus === false && deletionRequestError === 'balance_above_zero'">
      <p>{{ $t('accountSettings.deletionrequest.balanceabovezero') }}</p>
    </div>

    <div v-if="deletionRequestStatus === true">
      <p>{{ $t('accountSettings.deletionrequest.processing').replace('%s', dateFormat(onReviewTill)) }}</p>

      <Button
        type="dark"
        :click="openModalUndo"
      >{{ $t('accountSettings.deletionrequest.undorequest') }}</Button>
    </div>

    <Modal :close="closeModalRequest" v-if="modalRequest">
      <div v-if="!onReviewTill">
        <div class="modal-content">
          <p>{{ $t('accountSettings.deletionrequest.confirmationrequest') }}</p>
        </div>

        <div class="button-group">
          <Button
            class="modal-button"
            type="dark"
            :click="closeModalRequest"
            :class="{ disabled: createDeletionRequestLoader }"
          >{{ $t('accountSettings.deletionrequest.buttonundorequest') }}</Button>

          <Button
            class="modal-button"
            type="primary"
            :click="createRequest"
            :class="{ disabled: createDeletionRequestLoader }"
          >{{ $t('accountSettings.deletionrequest.buttonsendrequest') }}</Button>
        </div>
      </div>

      <div v-else>
        <p>{{ $t('accountSettings.deletionrequest.processing').replace('%s', dateFormat(onReviewTill)) }}</p>

        <div class="button-group">
          <Button
            class="modal-button"
            type="dark"
            :click="closeModalRequest"
          >{{ $t('accountSettings.deletionrequest.buttonclose') }}</Button>
        </div>
      </div>
    </Modal>

    <Modal :close="closeModalUndo" v-if="modalUndo">
      <div>
        <div class="modal-content">
          <p>{{ $t('accountSettings.deletionrequest.confirmationundo') }}</p>
        </div>

        <div class="button-group">
          <Button
            class="modal-button"
            type="dark"
            :click="closeModalUndo"
            :class="{ disabled: deleteDeletionRequestLoader }"
          >{{ $t('accountSettings.deletionrequest.buttonback') }}</Button>

          <Button
            class="modal-button"
            type="primary"
            :click="deleteRequest"
            :class="{ disabled: deleteDeletionRequestLoader }"
          >{{ $t('accountSettings.deletionrequest.buttonrequestundo') }}</Button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import Loader from './Loader'

import Button from '../../components/ui/button'
import Modal from './Modal'


export default {
  name: 'DeletionRequest',

  components: {
    Loader,
    Button,
    Modal,
  },

  data: () => {
    return {
      modalRequest: false,
      modalUndo: false,
    }
  },

  computed: {
    ...mapGetters([
      'deletionRequestLoader',
      'deletionRequestStatus',
      'deletionRequestError',

      'createDeletionRequestLoader',
      'onReviewTill',

      'deleteDeletionRequestLoader',
    ])
  },

  mounted() {
    this.$store.dispatch('getDeletionRequest')
  },

  methods: {
    openModalRequest() {
      this.modalRequest = true

      this.$ga.action({
        category: 'AccountRemoval',
        action: 'delete_account_click',
      })
    },

    closeModalRequest() {
      this.modalRequest = false

      this.$ga.action({
        category: 'AccountRemoval',
        action: 'confirm_cancel_click',
      })
    },

    openModalUndo() {
      this.modalUndo = true

      this.$ga.action({
        category: 'AccountRemoval',
        action: 'cancel_delete_account_click',
      })
    },

    closeModalUndo() {
      this.modalUndo = false

      this.$ga.action({
        category: 'AccountRemoval',
        action: 'confirm_cancel_back_click',
      })
    },

    createRequest() {
      this.$store.dispatch('createDeletionRequest')

      this.$ga.action({
        category: 'AccountRemoval',
        action: 'confirm_delete_account_click',
      })
    },

    async deleteRequest() {
      await this.$store.dispatch('deleteDeletionRequest')

      this.modalUndo = false

      this.$ga.action({
        category: 'AccountRemoval',
        action: 'confirm_cancel_delete_click',
      })
    },

    dateFormat(val) {
      const date = val.split(' ')[0].replace(/^(\d{4})-(\d{2})-(\d{2})/, '$3.$2.$1')
      const time = val.split(' ')[1]

      return date + ' ' + time
    },
  },
}
</script>

<style lang='scss' scoped>
@import '../../../sass/_variables.scss';
@import '../../../sass/_mixins.scss';

.deletion-request {
  font-size: 14px;
  line-height: 1.5;
  color: #939393;
  max-width: 615px;

  p {
    margin-bottom: 1em;
  }
}

.link-button {
  display: inline-block;
  color: #D63A3A;
  background: transparent;
  border: 0;
  border-bottom: 1px dashed rgba(#D63A3A, .5);

  &:hover {
    border-bottom: 1px dashed rgba(#D63A3A, .75);
  }
}

.modal-content {
  text-align: center;
  font-size: 18px;
  color: #f1f1f1;

  @include bp('sm') {
    font-size: 24px;
  }

}

.button-group {
  text-align: center;

  .modal-button {
    margin: 10px;

    &.disabled {
      opacity: .5;
      pointer-events: none;
    }
  }
}
</style>
